<template>
  <div>
    <div
      v-if="preloader"
      class="d-flex align-center justify-center flex-column"
      style="height: 100vh"
    >
      <template>
        <bubble-loader />
      </template>
    </div>
    <div v-else>
      <div class="custom-container pt-6">
        <v-card
          height="64px"
          width="100%"
          class="background mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
          style="
            position: fixed;
            z-index: 200;
            top: 0;
            width: 98%;
            padding-top: 16px;
          "
        >
          <v-card-title class="ml-0 pl-0">
            <p class="breadcrumb-text">Dashboard</p>
            <span
              ><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span
            >
          </v-card-title>
          <UserNavMenu />
        </v-card>
        <v-row align="stretch" class="px-4">
          <v-col cols="12" sm="6" md="8" class="d-flex flex-column">
            <h3 class="ml-4">Volt Dashboard</h3>
          </v-col>

          <v-col cols="12" sm="6" md="4" class="d-flex justify-end">
            <v-btn
              @click="filterDialog = true"
              dense
              rounded
              class="btn outline-btn elevation-0"
              ><v-icon class="pr-2">mdi-tune</v-icon>
              <span v-if="filterCount > 0">Filter ({{ filterCount }})</span>
              <span v-else>Filter</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-card
              class="pa-4 d-flex flex-column ml-4"
              elevation="2"
              style="height: 100%"
              v-if="teacherParticipationSummary.isDataAvailable"
            >
              <div class="d-flex justify-space-between">
                <span class="chart-title">
                  Teacher Participation Summary (In Percent)<br>  <div style="font-size: 12px">
                Overview of Assessment completion trends
              </div></br></span
                >
                <v-btn
                  class="btn outline-btn"
                  outlined
                  rounded
                  @click="downloadData('teacherParticipationSummary')"
                  :loading="downloadLoader"
                  ><v-icon>mdi-import mdi-rotate-90</v-icon></v-btn
                >
              </div>

            
              <div
                style="
                  display: flex;
                  gap: 35px;
                  justify-content: start;
                  padding-left: 15px;
                  padding-top: 20px;
                "
              >
                <div style="display: flex; gap: 24px; justify-content: start">
                  <div
                    style="
                      width: 40px;
                      height: 260px;
                      background-color: #e0e0e0;
                      border-radius: 20px;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: end;
                    "
                  >
                    <div
                      style="
                        position: relative;
                        background-color: #5ad684;
                        border-radius: 0px 0px 20px 20px;
                      "
                      :style="`height:${calculatePosition(
                        teacherParticipationSummary.attempted
                      )}%`"
                    >
                      <div
                        style="
                          position: relative;
                          top: -25px;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 40px;
                          width: 40px;
                          border-radius: 20px;
                          border: 2px solid #099438;
                          background-color: #82e0b7;
                          font-size: 12px
                        "
                      >
                        {{ calculatePercent(teacherParticipationSummary.attempted) }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 40px;
                    height: 260px;
                    background-color: #e0e0e0;
                    border-radius: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: end;
                  "
                >
                  <div
                    style="
                      position: relative;
                      background-color: #ffb86b;
                      border-radius: 0px 0px 20px 20px;
                    "
                    :style="`height:${calculatePosition(
                      teacherParticipationSummary.inProgress
                    )}%`"
                  >
                    <div
                      style="
                        position: relative;
                        top: -25px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                        border-radius: 20px;
                        border: 2px solid #c6761f;
                        background-color: #ffcd97;
                        font-size: 12px
                      "
                    >
                      {{ calculatePercent(teacherParticipationSummary.inProgress)}}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 40px;
                    height: 260px;
                    background-color: #e0e0e0;
                    border-radius: 20px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: end;
                  "
                >
                  <div
                    style="
                      position: relative;
                      background-color: #a3a3a3b2;
                      border-radius: 0px 0px 20px 20px;
                    "
                    :style="`height:${calculatePosition(
                      teacherParticipationSummary.notAttempted
                    )}%`"
                  >
                    <div
                      style="
                        position: relative;
                        top: -25px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 40px;
                        width: 40px;
                        border-radius: 20px;
                        border: 2px solid #666666cc;
                        background-color: #a3a3a3b2;
                        font-size: 12px;
                      "
                    >
                      {{ calculatePercent(teacherParticipationSummary.notAttempted) }}
                    </div>
                  </div>
                </div>

                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 10px;
                    padding-left: 20px;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #5ad684;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px">Attempted ({{teacherParticipationSummary.attempted}})</span>
                  </div>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #ffb86bb2;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px">In Progress ({{teacherParticipationSummary.inProgress}})</span>
                  </div>
                  <div style="display: flex; align-items: center; gap: 8px">
                    <div
                      style="
                        width: 20px;
                        height: 12px;
                        background-color: #a3a3a3b2;
                        border-radius: 15%;
                      "
                    ></div>
                    <span style="font-size: 12px">Not Attempted ({{teacherParticipationSummary.notAttempted}})</span>
                  </div>
                </div>
              </div>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              >
                <span class="chart-title">
                  Teacher Participation Summary (In Percent)<br>  <div style="font-size: 12px">
                Overview of Assessment completion trends
              </div></br></span
                >
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              class="pa-4 d-flex flex-column"
              elevation="2"
              style="height: 100%"
              v-if="testResultDistribution.isDataAvailable"
            >
              <div
                class="d-flex justify-space-between"
                style="margin-bottom: 0"
              >
                <span class="chart-title"
                  >Pass vs Fail Distribution (In Percent) <br>  <div style="font-size: 12px; margin-top: 0">
                Summary of Test Result Distribution
              </div></br></span
                >
            
                <v-btn
                  class="btn outline-btn"
                  outlined
                  rounded
                  @click="downloadData('passFailDistribution')"
                  :loading="downloadLoader"
                >
                  <v-icon>mdi-import mdi-rotate-90</v-icon>
                </v-btn>
              </div>

            

              <TeacherParticipationSummary
                :testResultDistributionInPercent="[
                  testResultDistributionInPercent.passPercentage,
                  testResultDistributionInPercent.failPercentage,
                ]"
                :testResultDistribution="[
                  testResultDistribution.pass,
                  testResultDistribution.fail,
                ]"
                
              />
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              >
              <span class="chart-title"
                  >Pass vs Fail Distribution (In Percent) <br>  <div style="font-size: 12px; margin-top: 0">
                Summary of Test Result Distribution
              </div></br></span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" class="d-flex flex-column">
            <v-card
              class="pa-4 d-flex flex-column"
              elevation="2"
              style="height: 100%"
              v-if="bestPerformingTeachers.length >= 1"
            >
              <!-- <span class="chart-title"> Best Performing Teachers</span> -->
                <div
                class="d-flex justify-space-between"
                style="margin-bottom: 0"
              >
                <span class="chart-title"
                  >Best Performing Teachers</span
                >
            
                <v-btn
                  class="btn outline-btn"
                  outlined
                  rounded
                  @click="downloadData('bestPerformingTeachers')"
                  :loading="downloadLoader"
                >
                  <v-icon>mdi-import mdi-rotate-90</v-icon>
                </v-btn>
              </div>

              
              <div style="font-size: 12px"></div>
              <v-list two-line>
                <template v-for="(teacher, i) in bestPerformingTeachers">
                  <v-list-item
                    :key="teacher.id"
                    :color="i % 2 === 0 ? 'blue lighten-4' : 'green lighten-4'"
                  >
                    <v-list-item-content>
                      <!-- First line -->
                      <v-list-item-title>{{ teacher.name }}</v-list-item-title>

                      <!-- Second line -->
                      <v-list-item-subtitle>
                        {{ teacher.level }} | {{ teacher.school }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <!-- Right aligned percentage -->
                    <v-list-item-action>
                      <span>{{ teacher.percent }}</span>
                    </v-list-item-action>
                  </v-list-item>

                  <!-- Divider after each list item except the last -->
                  <v-divider
                    v-if="i < bestPerformingTeachers.length - 1"
                  ></v-divider>
                </template>
              </v-list>
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
            >
              <span class="chart-title"> Best Performing Teachers </span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="!noSchools">
          <v-col cols="12">
            <v-card
              class="pa-4 d-flex flex-column ml-4"
              elevation="2"
              style="height: 100%"
              v-if="schoolWiseStatus.isDataAvailable"
            >
              
              <div
                class="d-flex justify-space-between"
                style="margin-bottom: 0"
              >
                <span class="chart-title"> School Wise Test status Overview (In Percent) <br><div style="font-size: 12px">Breakdown of Attempted tests with Pass/Fail and Not Attempted
                counts</div></br></span
                >
            
                <v-btn
                  class="btn outline-btn"
                  outlined
                  rounded
                  @click="downloadData('schoolWiseTestStatus')"
                  :loading="downloadLoader"
                >
                  <v-icon>mdi-import mdi-rotate-90</v-icon>
                </v-btn>
              </div>
              
              <SchoolWiseStatus
                :schoolLabels="schools"
                :passfail="schoolWiseStatus.passfail"
                :notAttempted="schoolWiseStatus.notAttempted"
                :notAttemptedPercent="schoolWiseStatus.notAttemptedPercentage"
                :passfailPercent="schoolWiseStatus.passfailPercent"
              />
            </v-card>
            <v-card
              class="pa-4 fill-height d-flex flex-column"
              elevation="2"
              v-else
              >
              <span class="chart-title"
                  >Pass vs Fail Distribution (In Percent) <br>  <div style="font-size: 12px; margin-top: 0">
                Summary of Test Result Distribution
              </div></br></span>
              <div
                class="d-flex justify-center align-center text-center"
                style="flex: 1"
              >
                No Data Available
              </div>
            </v-card>
          </v-col>
          
        </v-row>
      </div>
    </div>
    <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
      <v-card
        width="570px"
        height="100vh"
        class="filterDialogClass d-flex flex-column"
      >
        <v-row class="mt-4 mx-1">
          <v-col>
            <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
              Filter
            </div>
          </v-col>
          <v-col class="d-flex justify-end">
            <div @click="clearFilter" class="clear-filter-btn">
              Clear Filter
            </div>
          </v-col>
        </v-row>

        <v-tabs vertical>
          <div class="ml-3 mt-4 mr-4 filterLine">
            <v-tab class="black--text justify-start" active-class="activeTab">
              <div class="tab-content">
                <span>School</span>
                <span v-if="filters.school.selected.length > 0" class="ml-1"
                  ><div class="status-count-badge">
                    <p>{{ filters.school.selected.length }}</p>
                  </div></span
                >
              </div>
            </v-tab>
            <!-- <v-tab class="black--text justify-start" active-class="activeTab">
              <div class="tab-content">
                <span>Level</span>
                <span v-if="filters.level.selected.length > 0">
                  <div class="status-count-badge">
                    <p>
                      {{ filters.level.selected.length }}
                    </p>
                  </div>
                </span>
              </div>
            </v-tab> -->
          </div>
          <v-tab-item>
            <v-card flat height="580px" id="myScroll">
              <div class="px-4 pt-2 pb-0">
                <v-text-field
                  v-model="searchTerms.school"
                  label="Search Here..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  class="mb-2"
                />

                <!-- "All" Chip (stays under the search field, not scrolled away) -->
                 <v-chip
                      class="mb-2"
                      :class="{ 'active-chip': allSelectedStatus.school }"
                      @click="toggleAll('school')"
                      elevated
                    >
                      All
                    </v-chip>
              
              </div>
              <!-- Scrollable Chips Section -->
              <div
                id="myScroll"
                class="flex-grow-1 overflow-y-auto px-4 pb-4"
                style="max-height: calc(680px - 315px)"
              >
              <v-chip-group
  v-model="filters.school.selected"
  multiple
  column
  active-class="active-chip"
>
<v-chip
  v-for="(item, index) in filters.school.list"
  :key="item"
  v-show="matchesSearch(item)"
  :value="item"
  elevated
>
  {{ item }}
</v-chip>

</v-chip-group>

              </div>
            </v-card>
          </v-tab-item>
          <!-- <v-tab-item>
            <v-card flat height="580px" id="myScroll">
              <v-card-text>
                <v-text-field
                  v-model="searchTerms.level"
                  label="Search Here..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  class="px-4"
                />
                <div style="font-size: 14px; padding-left: 10px;">Note - Select 1–20 schools. Once 20 schools are selected, deselect an existing one to choose a new school.</div>
                <v-chip
                  class="mb-2"
                  :class="{ 'active-chip': allSelectedStatus.level }"
                  @click="toggleAll('level')"
                  elevated
                >
                  All
                </v-chip>

                <v-chip-group
                  v-model="filters.level.selected"
                  multiple
                  column
                  active-class="active-chip"
                >
                  <v-chip
                    v-for="(item, index) in filteredData.level"
                    :key="index"
                    :value="item"
                    elevated
                  >
                    {{ item }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item> -->

          <!--  -->
        </v-tabs>

        <div class="filterDialogButton">
          <v-card-actions class="px-6 pb-3">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              depressed
              class="btn outline-btn font-weight-medium pa-4"
              @click="filterDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="btn primary-btn pa-4"
              :disabled="filters.school.selected.length < 1"
              @click="
                
                  filterData(),
                  getFilterCount(),
                  (isApply = true)
              "
              >Apply</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";
import DashboardController from "@/controllers/DashboardController";
import TeacherParticipationSummary from "@/components/VoltDashboard/TeacherParticipationSummary.vue";
import SchoolWiseStatus from "@/components/VoltDashboard/SchoolWiseStatus.vue";
import SchoolController from "@/controllers/SchoolController";
import _ from "lodash";
import Papa from "papaparse";

export default {
  name: "VoltDashboard",
  components: {
    BubbleLoader,
    UserNavMenu,
    TeacherParticipationSummary,
    SchoolWiseStatus,
  },

  data() {
    return {
      schoolList: [],
      searchTerms: {
        school: "",
        level: "",
      },
      filters: {
        school: {
          list: [], // your schoolList array
          selected: [],
        },
        level: {
          list: [],
          selected: [],
        },
      },
      preloader: false,
      testResultDistribution: {},
      testResultDistributionInPercent: {},
      teacherParticipationSummary: {},
      filterDialog: false,
      filterCount: 0,
      schools: [],
      schoolWiseStatus: {},
      isApply: false,
      bestPerformingTeachers: [],
      schoolsWithCode: [],
      schoolList: [],
      downloadLoader: false,
      noSchools: false,
      MAX_SCHOOL_SELECTION: 20,
    };
  },
  methods: {
    matchesSearch(item) {
      if (!this.searchTerms.school) return true;
        return item.toLowerCase().includes(
        this.searchTerms.school.toLowerCase()
      );
    },
    isSchoolChipDisabled(item) {
      // Disable chip if 20 are already selected AND this chip is not one of them
      return (
        this.filters.school.selected.length >= this.MAX_SCHOOL_SELECTION &&
        !this.filters.school.selected.includes(item)
      );
    },
    handleSchoolChipClick(item, event) {
      // This method helps provide user feedback
      // The actual selection is handled by v-chip-group
      if (this.isSchoolChipDisabled(item)) {
        // You can add a toast/snackbar notification here if desired
        console.log('Maximum 20 schools can be selected. Please deselect one to choose another.');
      }
    },
    async getChartData() {
      this.loadingChartData = true;
      try {
        
        // this.schools = this.filters.school.selected.slice(0, 20);
        
        const requestBody = {
          levelFilter:
            this.filters.level.selected.filter(item => item !== "All").length > 0 &&
              this.filters.level.selected.filter(item => item !== "All").length < (this.filters.level.list.length - 1)
              ? this.filters.level.selected.filter(item => item !== "All").join(",")
              : "All",

          schoolFilter: Array.isArray(this.filters.school.selected)
                         ? this.filters.school.selected.join(",")  : (this.filters.school.selected ?? "")

        };
        const response = await DashboardController.getVoltDashboardData(requestBody);
        
        if(response && response.result){
          this.bestPerformingTeachers = response.result.bestPerformingTeachers || [];
          this.schoolWiseStatus = response.result.schoolWiseStatus || {};
          this.teacherParticipationSummary = response.result.teacherParticipationSummary || {
            attempted: 0,
            inProgress: 0,
            notAttempted: 0
          };
          this.testResultDistribution = response.result.testResultDistribution || {
            pass: 0,
            fail: 0
          };
          this.testResultDistributionInPercent = response.result.testResultDistributionInPercent || {
            passPercentage: 0,
            failPercentage: 0
          };

          this.schools = response.result.schoolWiseStatus.schools || [];
          if (response.result.schoolWiseStatus.schools) {
            
            this.filters.school.selected = response.result.schoolWiseStatus.schools;
          }
        
          // Calculate total here with safe access
          this.total = (this.teacherParticipationSummary.notAttempted || 0) + 
                       (this.teacherParticipationSummary.inProgress || 0) + 
                       (this.teacherParticipationSummary.attempted || 0);
        
          if (Object.keys(this.schoolWiseStatus).length === 0) {
            this.noSchools = true;
          } else {
            this.noSchools = false;
          }
        }
      } catch (error) {
        console.error('Error loading chart data:', error);
        // Set default values on error
        this.bestPerformingTeachers = [];
        this.schoolWiseStatus = {};
        this.teacherParticipationSummary = { attempted: 0, inProgress: 0, notAttempted: 0 };
        this.testResultDistribution = { pass: 0, fail: 0 };
        this.testResultDistributionInPercent = { passPercentage: 0, failPercentage: 0 };
        this.total = 0;
      } finally {
        this.loadingChartData = false;
        this.preloader = false;
      }
    },
    async downloadData(chartName) {
      const requestBody = {
        levelFilter:
          this.filters.level.selected.filter(item => item !== "All").length > 0 &&
            this.filters.level.selected.filter(item => item !== "All").length < (this.filters.level.list.length - 1)
            ? this.filters.level.selected.filter(item => item !== "All").join(",")
            : "All",

        schoolFilter:this.filters.school.selected.join(","),
        tab:chartName
      };
    const response = await DashboardController.downloadVoltDashboardData(requestBody);
      const fileName = chartName;
      const csvData = response.teachersDetails;
      this.downloadCSV(csvData, fileName);

    },
    async downloadCSV(csvData, fileName) {
      const csv = Papa.unparse(csvData);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      // this.loadingAssessmentsToDownload = false;
    },

    calculatePosition(value) {
      
      let position = (value / this.total) * 100;
      return position > 90 ? 90 : position < 5 ? 5 : position.toFixed(2);
      
    },
    calculatePercent(value) {
      
      let position = (value / this.total) * 100;
      return position.toFixed(2);
      
    },
    filterData() {
      this.getFilterCount();
    
      this.filters.level.selected = this.filters.level.selected.length <= 0 ? this.filters.level.list : this.filters.level.selected;
      this.filters.school.selected = this.filters.school.selected.length <= 0 ? this.filters.school.list : this.filters.school.selected;
      
      this.filterDialog = false;
      this.getChartData();
    },

    clearFilter() {
      this.searchTerm = ""; // Clear search term
      // Clear all filter selections
      Object.keys(this.filters).forEach((key) => {
        this.filters[key].selected = [];
      });
      this.getFilterCount();
    },
    toggleAll(type) {
      const filter = this.filters[type];
      const filtered = this.filteredData[type];
      const isAllSelected = this.allSelectedStatus[type];

      const getValue = (item) => (filter.allKey ? item[filter.allKey] : item);

      if (isAllSelected) {
        filter.selected = [];
      } else {
        filter.selected = filtered.map((item) => getValue(item));
      }
    },
    getFilterCount() {
      this.filterCount = Object.values(this.filters).filter(
        (filter) => filter.selected && filter.selected.length > 0
      ).length;
    },
    async getSchool() {
      try {
        const response = await SchoolController.getSchool();
        if (response && response.status == 200 && response.data && response.data.schools) {
          this.schoolsWithCode = response.data.schools;
          this.schoolList = this.schoolsWithCode.map((school) => school.name);

          this.filters.school.list = this.schoolsWithCode.map(
            (school) => school.name
          );
          this.schools = this.schoolsWithCode.map(
            (school) => school.name
          );
          this.filters.school.selected = this.schoolList;

        
        } else {
          console.error("Schools Not Found!!");
          this.filters.school.list = [];
          this.filters.school.selected = [];
        }
      } catch (error) {
        console.error('Error fetching schools:', error);
        this.filters.school.list = [];
        this.filters.school.selected = [];
      }
    },
  },

  async mounted() {
    try {
      this.preloader = true;
      const schools = this.$store.state.userInfo?.role?.schools;
    
      if(schools == 'All'){
         await this.getSchool();
      }else{
        this.filters.school.list =  Array.isArray(this.$store.state.userInfo?.role?.schools) ? this.$store.state.userInfo?.role?.schools  : this.$store.state.userInfo?.role?.schools
      ? [this.$store.state.userInfo?.role?.schools]
      : [];

        this.filters.school.selected = [...this.filters.school.list];
      }
      this.filters.level.list = [];
      this.filters.level.selected = [];
      await this.getChartData();
    } catch (error) {
      console.error('Error in mounted:', error);
      this.preloader = false;
    }
    this.filters.level.list = [];
    this.filters.level.selected = [];
  
  },
  computed: {
    filteredData() {
      const result = {};

      for (const [key, filter] of Object.entries(this.filters)) {
        // Safety check: ensure filter and filter.list exist
        if (!filter || !filter.list) {
          result[key] = [];
          continue;
        }

        let items = [...filter.list]; // Create a copy to avoid mutations

        // Support objects (like campaigns) or simple strings (like schools)
        const getValue = (item) => (filter.allKey ? item[filter.allKey] : item);

        // Remove "All" items if they exist
        items = items.filter((item) => {
          const value = getValue(item);
          return value !== "All";
        });

        // Apply search filtering
        const term = this.searchTerms[key]?.toLowerCase() || "";
        if (term) {
          items = items.filter((item) => {
            const value = getValue(item);
            return value && value.toString().toLowerCase().includes(term);
          });
        }

        result[key] = items;
      }
    
      return result;
    },

    allSelectedStatus() {
      const result = {};

      for (const [key, filter] of Object.entries(this.filters)) {
        // Safety check: ensure filter exists and selected array exists
        if (!filter || !Array.isArray(filter.selected)) {
          result[key] = false;
          continue;
        }

        const filteredItems = this.filteredData[key] || [];
        const getValue = (item) => (filter.allKey ? item[filter.allKey] : item);

        // If no filtered items, mark as false
        if (filteredItems.length === 0) {
          result[key] = false;
          continue;
        }

        result[key] = filteredItems.every((item) =>
          filter.selected.includes(getValue(item))
        );
      }

      return result;
    },
  },
};
</script>
